export default "__VITE_ASSET__DSvJmFF9__"